import { ProgressBar } from '@sgme/ui';
import classNames from 'classnames';
import { PriceSidePanelStatus } from 'components/shared/Price/shared';
import type { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

interface WaitingPriceProps {
  onCancel?(): void;
  color: 'success' | 'info' | 'warning' | 'danger' | 'primary' | 'secondary';
  children?: ReactNode;
  progressInPercent?: number;
  topRightActions?: ReactNode;
}

export function WaitingPrice({ color, children, progressInPercent = 0, topRightActions, onCancel }: WaitingPriceProps) {
  const { formatMessage } = useIntl();
  return (
    <>
      <PriceSidePanelStatus
        color={color}
        topLeft={
          <div title={formatMessage({ id: 'sidePanel.status.title' })}>
            <FormattedMessage id="sidePanel.status.quoting" />
          </div>
        }
        topRightActions={topRightActions}
      >
        {children}
        {onCancel && (
          <div className="d-flex flex-grow-1 align-items-end h-100">
            <div className="d-flex justify-content-end p-2 w-100">
              <i className={classNames('icon icon-md btn btn-sm', `btn-flat-${color}`)} onClick={onCancel}>
                close
              </i>
            </div>
          </div>
        )}
      </PriceSidePanelStatus>
      <ProgressBar size="sm" color={color} value={progressInPercent} />
    </>
  );
}
